/**
 * NOCTRA — minimal progressive enhancement.
 *
 * Everything on the redesigned homepage and collection page works without this
 * file: sorting and filtering are plain GET forms, filters are native
 * <details> disclosures, and the newsletter is a standard Shopify customer
 * form. This module only removes the extra click.
 *
 * Loaded as an ES module, so the browser evaluates it exactly once per page
 * even when a section is re-rendered in the Theme Editor. All listeners are
 * delegated from `document`, so re-rendered markup is picked up automatically
 * without re-binding.
 */

const HTML = document.documentElement;

// Lets CSS hide the no-JS fallback submit buttons.
HTML.setAttribute('data-noctra-js', 'true');

/**
 * Submit the owning form as soon as a NOCTRA sort control changes.
 * @param {Event} event
 */
function handleSortChange(event) {
  const target = event.target;
  if (!(target instanceof HTMLSelectElement)) return;
  if (!target.matches('[data-noctra-auto-submit]')) return;

  const form = target.form;
  if (form) form.requestSubmit();
}

/**
 * Put the newsletter button into a busy state while the form navigates.
 * @param {Event} event
 */
function handleNewsletterSubmit(event) {
  const form = event.target;
  if (!(form instanceof HTMLFormElement)) return;
  if (!form.matches('[data-noctra-newsletter]')) return;
  if (!form.checkValidity()) return;

  const button = form.querySelector('button[type="submit"]');
  if (!(button instanceof HTMLButtonElement)) return;

  button.setAttribute('aria-busy', 'true');
  button.disabled = true;

  // Restore the control if the browser returns to a cached version of the page.
  window.addEventListener(
    'pageshow',
    () => {
      button.removeAttribute('aria-busy');
      button.disabled = false;
    },
    { once: true }
  );
}

document.addEventListener('change', handleSortChange);
document.addEventListener('submit', handleNewsletterSubmit);
